import type {
	IntegrationPopupViewProps,
	IntegrationViewChildrenProps,
	OnOpen,
	OnClose,
} from './types';
import { IntegrationPopup as IntegrationPopupDI } from './ui/integration-popup';

export type { IntegrationPopupViewProps, IntegrationViewChildrenProps, OnOpen, OnClose };

export { IntegrationPopupDI };

export const PopupIntegrationDI = ({
	IntegrationPopup = IntegrationPopupDI,
	...props
}: IntegrationPopupViewProps) =>
	props.children({
		IntegrationView: IntegrationPopup,
		atlassianSwitcherCustomizationProps: {
			appearance: 'standalone',
		},
	});
